<div class="mpp-multiplos-container">

  <!-- ── HEADER ──────────────────────────────────────────────────────────── -->
  <div mat-dialog-title class="mpp-header">
    <span>💳 Múltiplos Pagamentos</span>
    <button mat-icon-button (click)="fecharDialog()" [disabled]="isLoading" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ── LOADING INICIALIZAÇÃO ───────────────────────────────────────────── -->
  <div *ngIf="etapa === 'inicializando'" class="mpp-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Iniciando sessão de composição...</p>
  </div>

  <!-- ── ERRO INICIALIZAÇÃO ──────────────────────────────────────────────── -->
  <div *ngIf="erroMsg && etapa !== 'inicializando'" class="mpp-erro">
    <mat-icon color="warn">error</mat-icon>
    <span>{{ erroMsg }}</span>
  </div>

  <!-- ── CONTEÚDO PRINCIPAL ─────────────────────────────────────────────── -->
  <mat-dialog-content *ngIf="etapa !== 'inicializando' && !erroMsg">

    <!-- Resumo de valores -->
    <div class="mpp-resumo-valores">
      <div class="valor-item">
        <span class="label">Valor Total</span>
        <span class="value">{{ composicao?.valorTotal | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="valor-item pago">
        <span class="label">Pago</span>
        <span class="value">{{ composicao?.valorPago | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="valor-item saldo" [class.zerado]="saldoRestante <= 0">
        <span class="label">Saldo Restante</span>
        <span class="value">{{ saldoRestante | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
    </div>

    <!-- Barra de progresso (RF-11 visual) -->
    <mat-progress-bar
      mode="determinate"
      [value]="progressoPct"
      color="primary"
      style="margin-bottom: 12px;">
    </mat-progress-bar>

    <!-- ── ITENS JÁ ADICIONADOS ───────────────────────────────────────────── -->
    <div class="mpp-itens" *ngIf="composicao?.itens?.length > 0">
      <h4 class="mpp-section-title">Pagamentos Registrados</h4>
      <mat-table [dataSource]="composicao.itens" class="itens-table">

        <ng-container matColumnDef="sequencia">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.sequencia }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="forma">
          <mat-header-cell *matHeaderCellDef>Forma</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ labelFormaPagamento(item.formaPagamento) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="valor">
          <mat-header-cell *matHeaderCellDef>Valor</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ item.valor | currency:'BRL':'symbol':'1.2-2' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let item">{{ labelStatusItem(item.status) }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="['sequencia','forma','valor','status']"></mat-header-row>
        <mat-row *matRowDef="let row; columns: ['sequencia','forma','valor','status']"></mat-row>
      </mat-table>
    </div>

    <!-- ── ADICIONAR NOVO PAGAMENTO (somente se saldo > 0) ──────────────── -->
    <ng-container *ngIf="saldoRestante > 0.01 && etapa !== 'finalizado'">
      <h4 class="mpp-section-title">Adicionar Pagamento</h4>
      <form [formGroup]="form" class="mpp-form">

        <!-- Forma de pagamento -->
        <mat-form-field appearance="outline">
          <mat-label>Forma de Pagamento</mat-label>
          <mat-select formControlName="formaPagamento" (selectionChange)="onFormaPagamentoChange()">
            <mat-option *ngFor="let fp of formasPgtoFiltradas" [value]="fp.value">
              {{ fp.label }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('formaPagamento').hasError('required')">Selecione a forma</mat-error>
          <!-- RF-12: Mostrar mensagem se PIX está em modo manual -->
          <mat-hint *ngIf="!pixTefHabilitado && pixMensagemModoManual">
            ℹ️ {{ pixMensagemModoManual }}
          </mat-hint>
        </mat-form-field>

        <!-- Valor (apenas para TEF — boleto usa saldo * 1.20 automático) -->
        <mat-form-field appearance="outline" *ngIf="!isBoleto">
          <mat-label>Valor (R$)</mat-label>
          <input matInput type="text" formControlName="valor"
                 placeholder="0,00" (input)="onValorInput($event)" (blur)="onValorBlur()">
          <mat-hint>Máximo: {{ saldoRestante | currency:'BRL':'symbol':'1.2-2' }}</mat-hint>
          <mat-error *ngIf="form.get('valor').hasError('required')">Informe o valor</mat-error>
          <mat-error *ngIf="form.get('valor').hasError('min')">Valor mínimo R$ 0,01</mat-error>
        </mat-form-field>

        <!-- US-004 v2: Quantidade de parcelas (somente CC) -->
        <mat-form-field appearance="outline" *ngIf="isCartaoCredito && parcelasDisponiveis.length > 0">
          <mat-label>Quantidade de Parcelas</mat-label>
          <mat-select formControlName="parcelas">
            <mat-option *ngFor="let p of parcelasDisponiveis" [value]="p.value">
              {{ p.label }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="parcelasDisponiveis.length > 1">
            Máximo: {{ parcelasDisponiveis.length }}x
          </mat-hint>
        </mat-form-field>


        <!-- Data de vencimento (somente boleto) -->
        <mat-form-field appearance="outline" class="full-width" *ngIf="isBoleto">
          <mat-label>Data de Vencimento</mat-label>
          <input matInput [matDatepicker]="pickerVenc" formControlName="dataVencimento">
          <mat-datepicker-toggle matSuffix [for]="pickerVenc"></mat-datepicker-toggle>
          <mat-datepicker #pickerVenc></mat-datepicker>
          <mat-hint>Valor do boleto: {{ saldoRestante * 1.20 | currency:'BRL':'symbol':'1.2-2' }} (+ 20% acréscimo)</mat-hint>
          <mat-error *ngIf="form.get('dataVencimento').hasError('required')">Informe a data de vencimento</mat-error>
        </mat-form-field>

        <!-- TEF em andamento -->
        <div *ngIf="etapa === 'tef_pendente'" class="tef-aguardando">
          <mat-spinner diameter="24"></mat-spinner>
          <span>Aguardando TEF... Siga as instruções na maquininha.</span>
        </div>

        <!-- US-004 v2: Aviso sobre auto-geração de boleto -->
        <div class="mpp-info-boleto-auto">
          <mat-icon color="primary">info</mat-icon>
          <span>Se houver saldo pendente ao finalizar, será gerado automaticamente um boleto com vencimento em 10 dias.</span>
        </div>

      </form>
    </ng-container>

    <!-- Mensagem quando saldo zerado mas ainda não finalizou -->
    <div *ngIf="saldoRestante <= 0.01 && etapa !== 'finalizado'" class="mpp-saldo-ok">
      <mat-icon color="primary">check_circle</mat-icon>
      <span>Saldo coberto! Clique em <strong>Finalizar</strong> para registrar os pagamentos.</span>
    </div>

  </mat-dialog-content>

  <!-- ── RF-08: Confirmação de cancelamento com TEF aprovado ─────────────── -->
  <mat-dialog-content *ngIf="confirmarCancelamento" class="mpp-confirm-cancelamento">
    <mat-icon color="warn">warning</mat-icon>
    <p><strong>Atenção!</strong> Há TEF(s) já aprovados nesta composição.</p>
    <p>Ao cancelar, o valor aprovado via TEF precisará ser <strong>estornado manualmente na maquininha</strong>.</p>
    <p>Deseja prosseguir com o cancelamento?</p>
  </mat-dialog-content>

  <!-- ── ACTIONS ──────────────────────────────────────────────────────────── -->
  <mat-dialog-actions *ngIf="etapa !== 'inicializando'" align="end">

    <!-- Ações durante confirmação de cancelamento (RF-08) -->
    <ng-container *ngIf="confirmarCancelamento">
      <button mat-button (click)="confirmarCancelamento = false" [disabled]="isLoading">
        Voltar
      </button>
      <button mat-raised-button color="warn" (click)="executarCancelamento()" [disabled]="isLoading">
        <mat-icon>warning</mat-icon>
        Confirmar Cancelamento
      </button>
    </ng-container>

    <!-- Ações normais -->
    <ng-container *ngIf="!confirmarCancelamento">
      <button mat-button color="warn"
              (click)="cancelar()"
              [disabled]="isLoading">
        Cancelar Composição
      </button>

      <!-- Botão Processar TEF (para pagamentos com TEF) -->
      <button mat-raised-button color="primary"
              *ngIf="!isBoleto && formaPagamentoSelecionada && etapa !== 'tef_pendente'"
              (click)="processarTef()"
              [disabled]="isLoading || form.invalid">
        <mat-icon>contactless</mat-icon>
        Processar TEF
      </button>

      <!-- Botão Gerar Boleto (para boletos) -->
      <button mat-raised-button color="accent"
              *ngIf="isBoleto && etapa !== 'tef_pendente'"
              (click)="processarBoleto()"
              [disabled]="isLoading || form.invalid">
        <mat-icon>receipt</mat-icon>
        Gerar Boleto
      </button>

      <!-- Botão Finalizar -->
      <button mat-raised-button color="primary"
              (click)="finalizar()"
              [disabled]="!podeFinalizar || isLoading">
        <mat-icon>check</mat-icon>
        Finalizar
      </button>
    </ng-container>

  </mat-dialog-actions>

</div>
